import React from 'react';
import Cloud from '../assets/icons8-cloud-done-48 1.svg';
import phone from '../assets/phone-call-svgrepo-com 1.png';
import security from '../assets/Security02.png';
import './BookingIntro.css';

const BookingIntro = () => {
    return (
        <div className='booking-intro-container'>
            <p>Thanks for choosing Vigovia! Your dream tour is just around the corner! 🏖️</p>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>

            <div className='booking-intro-title'>
                <img src={Cloud} style={{height:'80px'}} alt="Cloud icon" />
                <div style={{fontSize:'33px',fontWeight:'600',marginTop:'10px'}}>Package Booked</div>
            </div>
            
            <div className='booking-intro-buttons'>
                <button className='sos'> SOS <img src={phone}/></button>
                <button className='call-us'> Call us <img src={security}/></button>
            </div>

            </div>

        </div>
    );
};

export default BookingIntro;
